import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=04c0b5d6&scoped=true&"
import script from "./Radar.vue?vue&type=script&lang=js&"
export * from "./Radar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0b5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c0b5d6')) {
      api.createRecord('04c0b5d6', component.options)
    } else {
      api.reload('04c0b5d6', component.options)
    }
    module.hot.accept("./Radar.vue?vue&type=template&id=04c0b5d6&scoped=true&", function () {
      api.rerender('04c0b5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/Radar.vue"
export default component.exports